import { render } from "./notice_view.vue?vue&type=template&id=ae691d6a"
import script from "./notice_view.vue?vue&type=script&lang=js"
export * from "./notice_view.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__